// extracted by mini-css-extract-plugin
module.exports = {"root":"FeatureModal_root__wElNf","tabContainer":"FeatureModal_tabContainer__2Stn7","tabItemContainer":"FeatureModal_tabItemContainer__LL09o"};